import { getMarks } from "src/Services/assignments_api";
import "../Common/css/styles.css";
import "../Common/css/user.css";
import { useEffect } from "react";
import TableToolbar from "src/Components/TableToolbar";
import React from "react";
import { PlusOutlined } from "@ant-design/icons";

export default function Marks() {
    const userId = sessionStorage.getItem("userId") || "";
    const programme = sessionStorage.getItem("programme") || "";
    const stream = sessionStorage.getItem("stream") || "";
    const token = sessionStorage.getItem("token") || "";

    const [searchTerm, setSearchTerm] = React.useState("");
    const [marksData, setMarksData] = React.useState<any[]>([]);
    const [openModal, setOpenModal] = React.useState(false);

    const handleGetMarks = async () => {
        try {
            const response = await getMarks(programme, stream, userId, token);
            const raw = response.data.data || [];

            // 1. filter only markStatus == 2
            const filtered = raw.filter((x: any) => x.markStatus === 2);

            // 2. group by materialAssignmentId and take the highest attempt
            const latestAttempts: any[] = [];

            const grouped = filtered.reduce((acc: any, item: any) => {
                if (!acc[item.materialAssignmentId]) {
                    acc[item.materialAssignmentId] = [];
                }
                acc[item.materialAssignmentId].push(item);
                return acc;
            }, {});

            Object.values(grouped).forEach((list: any) => {
                // pick the record with highest attempt
                const latest = list.sort((a: any, b: any) => b.attempt - a.attempt)[0];
                latestAttempts.push(latest);
            });

            setMarksData(latestAttempts);
        } catch (error) {
            console.error("Error fetching marks:", error);
            setMarksData([]);
        }
    };

    useEffect(() => {
        handleGetMarks();
    }, []);

    const filteredMarks = marksData.filter((item) => {
        const term = searchTerm.toLowerCase();
        return (
            item.subject?.toLowerCase().includes(term) ||
            item.fileName?.toLowerCase().includes(term)
        );
    });

    return (
        <div className="comman-outer">
            <TableToolbar
                title="Assignment Marks"
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                isButton={false}
                buttonText="Marks"
                onButtonClick={() => setOpenModal(true)}
                buttonIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
            />

            <div className="space-bar"></div>

            {/* map data  */}
            <div>
                {filteredMarks.length === 0 ? (
                    <div style={{ justifyContent: "center", alignItems: "center" }} className="card-outer">
                        No records found
                    </div>
                ) : (
                    filteredMarks.map((item, index) => (
                        <div className="card-outer" key={index}>
                            <div className="card-outer1">
                                <p className="t-card"><b>Subject:</b> {item.subject !== null ? item.subject : item.stream}</p>
                                <p className="t-card"><b>Assignment:</b> {item.fileName}</p>
                                <p className="t-card"><b>Marks:</b> {item.marks}%</p>
                                <p className="t-card"><b>Attempt:</b> {item.attempt}</p>
                            </div>
                        </div>
                    ))
                )}
            </div>

            <div className="pagination-footer"></div>

        </div>
    );
}